import React from "react";
import { useHistory } from "react-router-dom";

import BlogImage from "./BlogImage";
import axios from "axios";

const BlogCard = ({
  blog,
  featured = false,
  showActions = false,
  handleEdit,
  handleDelete
}) => {

  const history = useHistory();

  const openBlog = async() => {
    
    history.push(
      `/blog/${blog.slug}`
    );
  };

  return (
    <article
      className={`blog-card ${
        featured
          ? "featured-card"
          : ""
      }`}
      
    >

      <BlogImage
        src={blog.image}
        alt={blog.title}
        color={blog.color}
        showActions={showActions}
        blog={blog}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
      />

      <div className="blog-content" onClick={openBlog}>

        <div className={`blog-category article-category ${blog.color || "pink"}`}>
          {blog.category}
        </div>

        <h2>
          {blog.title}
        </h2>

        {blog.description && (
          <p>
            {blog.description}
          </p>
        )}

        <div className="blog-meta">
          {blog.date} ·{" "}
          {blog.readTime}
        </div>

      </div>

    </article>
  );
};

export default BlogCard;